import { protectedApi } from "./protectedApi";
import { APIS } from "../constants/apiConstant";

const base64ToBlob = (base64, mimeType = "application/pdf") => {
  const binary = atob(String(base64 || ""));
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return new Blob([bytes], { type: mimeType });
};

export async function fetchEmployeeTimesheetPdf(employeeId, invoiceMonth) {
  const url = APIS.TASK_EMPLOYEE_TIMESHEET_PDF.replace(":userId", String(employeeId));
  const response = await protectedApi({
    url,
    method: "GET",
    params: { month: invoiceMonth },
  });
  const data = response?.data?.data || {};
  const pdfBase64 = data.pdfBase64;
  const fileName = data.fileName || "timesheet.pdf";
  if (!pdfBase64) {
    throw new Error("Timesheet PDF is not available for this employee.");
  }
  return {
    blob: base64ToBlob(pdfBase64),
    fileName,
  };
}
